package com.xtream.composeapp.viewmodel

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.luminance
import androidx.lifecycle.ViewModel
import com.kmpalette.palette.graphics.Palette
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow

class DominantColorViewModel : ViewModel() {

    private val _backdropColor = MutableStateFlow<Color?>(null)
    val backdropColor = _backdropColor.asStateFlow()


    fun updateColorFromPalette(palette: Palette?) {
        if (palette == null) return

        val dominant = palette.dominantSwatch?.rgb
            ?.let { Color(it) }
            ?: Color.Black

        val lum = dominant.luminance()

        _backdropColor.value = if (lum > 0.1f) {
            val factor = 0.1f / lum
            Color(
                red = (dominant.red * factor).coerceIn(0f, 1f),
                green = (dominant.green * factor).coerceIn(0f, 1f),
                blue = (dominant.blue * factor).coerceIn(0f, 1f),
                alpha = 1f
            )
        } else {
            dominant
        }
    }
}